export function callPhoneNumber(phoneNumber) {
  const cleaned = String(phoneNumber || "").replace(/[^\d+]/g, "");
  if (!cleaned) {
    return { status: "missing_phone" };
  }
  window.location.href = `tel:${cleaned}`;
  return { status: "dialing", phoneNumber: cleaned };
}
